import React, { useContext } from 'react'
import { AccordionContext, Row, useAccordionToggle } from 'react-bootstrap';

function CustomAccordionToggle({ inputRef, children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(isCurrentEventKey),
    );

    return (
        <Row ref={inputRef} style={{ alignItems: "center", cursor: "pointer" }}
            onClick={decoratedOnClick}
        >
            {children}
        </Row>
    );
}
export default CustomAccordionToggle